import { Deal } from "@Types/deal";
import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";

const FinancialInfo = ({ deal }: { deal: Deal }) => {
  const dealTotal = deal?.data?.info?.payment?.dealTotal ?? 0;

  return (
    <Paper title="Financials">
      <Grid container xs={12}>
        <Grid xs={12}>
          {renderFieldData(
            "Loan amount",
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(dealTotal)
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FinancialInfo;
